export const CREATE_PROPOSAL_REQUEST = "CREATE_PROPOSAL_REQUEST";
export const CREATE_PROPOSAL_SUCCESS = "CREATE_PROPOSAL_SUCCESS";
export const CREATE_PROPOSAL_FAIL = "CREATE_PROPOSAL_FAIL";
export const CREATE_PROPOSAL_RESET = "CREATE_PROPOSAL_RESET";

export const APPROVER_GET_ALL_PROPOSAL_REQUEST =
  "APPROVER_GET_ALL_PROPOSAL_REQUEST";
export const APPROVER_GET_ALL_PROPOSAL_SUCCESS =
  "APPROVER_GET_ALL_PROPOSAL_SUCCESS";
export const APPROVER_GET_ALL_PROPOSAL_FAIL = "APPROVER_GET_ALL_PROPOSAL_FAIL";
export const APPROVER_GET_ALL_PROPOSAL_RESET =
  "APPROVER_GET_ALL_PROPOSAL_RESET";

export const APPROVE_PROPOSAL_REQUEST = "APPROVE_PROPOSAL_REQUEST";
export const APPROVE_PROPOSAL_SUCCESS = "APPROVE_PROPOSAL_SUCCESS";
export const APPROVE_PROPOSAL_FAIL = "APPROVE_PROPOSAL_FAIL";
export const APPROVE_PROPOSAL_RESET = "APPROVE_PROPOSAL_RESET";
